import { createSelector } from 'reselect';
import { getProfileId } from './getProfileId';

export const getProfileDetails = createSelector(
	(store) => store.ProfileVenue,
	getProfileId,
	(state, profileId) => {
		const { data } = state.loadEntity;
		return data ? data[profileId] || {} : {};
	},
);
